/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCustomMetadataEntryLabelValueDto } from '../models/CreateCustomMetadataEntryLabelValueDto';
import type { CreateCustomMetadataEntryStringValueDto } from '../models/CreateCustomMetadataEntryStringValueDto';
import type { CreateCustomMetadataEntryTeamValueDto } from '../models/CreateCustomMetadataEntryTeamValueDto';
import type { CreateCustomMetadataEntryUserValueDto } from '../models/CreateCustomMetadataEntryUserValueDto';
import type { CreateCustomMetadataRequestDto } from '../models/CreateCustomMetadataRequestDto';
import type { GetCustomMetadataEntryLabelValueResponseDto } from '../models/GetCustomMetadataEntryLabelValueResponseDto';
import type { GetCustomMetadataEntryStringValueResponseDto } from '../models/GetCustomMetadataEntryStringValueResponseDto';
import type { GetCustomMetadataEntryTeamValueResponseDto } from '../models/GetCustomMetadataEntryTeamValueResponseDto';
import type { GetCustomMetadataEntryUserValueResponseDto } from '../models/GetCustomMetadataEntryUserValueResponseDto';
import type { GetCustomMetadataResponseDto } from '../models/GetCustomMetadataResponseDto';
import type { SearchCollectionGetCustomMetadataListResponseDto } from '../models/SearchCollectionGetCustomMetadataListResponseDto';
import type { UpdateCustomMetadataEntryLabelValueDto } from '../models/UpdateCustomMetadataEntryLabelValueDto';
import type { UpdateCustomMetadataEntryStringValueDto } from '../models/UpdateCustomMetadataEntryStringValueDto';
import type { UpdateCustomMetadataEntryTeamValueDto } from '../models/UpdateCustomMetadataEntryTeamValueDto';
import type { UpdateCustomMetadataEntryUserValueDto } from '../models/UpdateCustomMetadataEntryUserValueDto';
import type { UpdateCustomMetadataRequestDto } from '../models/UpdateCustomMetadataRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomMetadataService {

    /**
     * Get a custom metadata details
     * @returns GetCustomMetadataResponseDto Successfully get Custom Metadata details
     * @throws ApiError
     */
    public static getCustomMetadata({
        id,
        textSearch,
        page,
        itemsPerPage = 25,
    }: {
        /**
         * Custom metadata id
         */
        id?: string,
        /**
         * Text search
         */
        textSearch?: string,
        /**
         * The requested page number. Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The number of elements to be returned inside the page. Pass a value of -1, to bypass pagination and fetch all items
         */
        itemsPerPage?: number,
    }): CancelablePromise<GetCustomMetadataResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/custom-metadata',
            query: {
                'id': id,
                'textSearch': textSearch,
                'page': page,
                'itemsPerPage': itemsPerPage,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a custom metadata
     * @returns any Successfully create Custom Metadata
     * @throws ApiError
     */
    public static createCustomMetadata({
        requestBody,
    }: {
        requestBody: CreateCustomMetadataRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/custom-metadata',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a custom metadata entry
     * @returns any Successfully create Custom Metadata Entry
     * @throws ApiError
     */
    public static createCustomMetadataEntry({
        customMetadataId,
        requestBody,
    }: {
        customMetadataId: string,
        requestBody: (CreateCustomMetadataEntryLabelValueDto | CreateCustomMetadataEntryStringValueDto | CreateCustomMetadataEntryTeamValueDto | CreateCustomMetadataEntryUserValueDto),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/custom-metadata-entry',
            query: {
                'customMetadataId': customMetadataId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a custom metadata entry
     * @returns void
     * @throws ApiError
     */
    public static deleteCustomMetadataEntry({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ui/v1/custom-metadata-entry/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a custom metadata entry
     * @returns any Successfully get Custom Metadata Entry
     * @throws ApiError
     */
    public static getCustomMetadataEntry({
        id,
    }: {
        id: string,
    }): CancelablePromise<(GetCustomMetadataEntryLabelValueResponseDto | GetCustomMetadataEntryStringValueResponseDto | GetCustomMetadataEntryTeamValueResponseDto | GetCustomMetadataEntryUserValueResponseDto)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/custom-metadata-entry/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a custom metadata entry
     * @returns any Successfully update Custom Metadata Entry
     * @throws ApiError
     */
    public static updateCustomMetadataEntry({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: (UpdateCustomMetadataEntryLabelValueDto | UpdateCustomMetadataEntryStringValueDto | UpdateCustomMetadataEntryTeamValueDto | UpdateCustomMetadataEntryUserValueDto),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/ui/v1/custom-metadata-entry/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get all custom metadata
     * @returns SearchCollectionGetCustomMetadataListResponseDto Successfully get Custom Metadata list
     * @throws ApiError
     */
    public static getAllCustomMetadata(): CancelablePromise<SearchCollectionGetCustomMetadataListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/custom-metadata/list',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a custom metadata
     * @returns void
     * @throws ApiError
     */
    public static deleteCustomMetadata({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ui/v1/custom-metadata/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a custom metadata
     * @returns any Successfully update Custom Metadata
     * @throws ApiError
     */
    public static updateCustomMetadata({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateCustomMetadataRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/ui/v1/custom-metadata/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
